/**
 * @class
 * @classdesc Model for Fleet on DB
 * * */
export default class Fleet {
  /**
   *Constructor - sets a model for fleet Data according to DB
   * @param {String} id
   * @param {String} name
   * @param {String} description
   * @param {String} appInfoText
   * @param {String} type
   * @param {String} validInType
   * @param {String} region
   * @param {Array.<Place>} places
   * @param {Array} zones
   * @param {String} validFrom
   * @param {String} validTo
   * @param {String} appRegistrationCode
   * @param {String} notificationEmails
   * @param {Boolean} autoApprove
   * @param {String} approvalMessage
   * @param {Array.<FleetUser>} fleetUsers
   * @param {String} publicRegistrationLinkUuid
   * @param {Boolean} isPublicRegistrationLinkEnabled
   * @param {Boolean} startSessionsWithLPR
   * @param {String} registrationOpenUntil
   * @param {String} appId
   * @param {Array.<PromoCode>} promoCodes
   * @param {String} managers
   * @param {String} registrationRequestReceivedMessage
   * @param {Boolean} resetUsedLimitsEachMonth
   * @param {Number} dailyLimitInCentsPerUser
   * @param {Number} monthlyLimitInCentsPerUser
   * @param {Number} maxNumberOfUsers
   * @param {String} currency
   */

  #FleetObject = {}

  constructor(
    id,
    name,
    description,
    appInfoText,
    type,
    validInType,
    region,
    places,
    zones,
    validFrom,
    validTo,
    appRegistrationCode,
    notificationEmails,
    autoApprove,
    approvalMessage,
    fleetUsers,
    publicRegistrationLinkUuid,
    isPublicRegistrationLinkEnabled,
    startSessionsWithLPR,
    registrationOpenUntil,
    appId,
    managers,
    registrationRequestReceivedMessage,
    resetUsedLimitsEachMonth,
    dailyLimitInCentsPerUser,
    monthlyLimitInCentsPerUser,
    maxNumberOfUsers,
    currency
  ) {
    this.#FleetObject.Id = id || null
    this.#FleetObject.Name = name || ''
    this.#FleetObject.Description = description || ''
    this.#FleetObject.AppInfoText = appInfoText || ''
    this.#FleetObject.Type = type || 'POSTPAID'
    this.#FleetObject.ValidInType = validInType || 'PLACES'
    this.#FleetObject.Region = region || ''
    this.#FleetObject.Places = places || []
    this.#FleetObject.Zones = zones || []
    this.#FleetObject.ValidFrom = validFrom || this.getValidFrom()
    this.#FleetObject.ValidTo = validTo || this.getValidTo()
    this.#FleetObject.AppRegistrationCode = appRegistrationCode || ''
    this.#FleetObject.NotificationEmails = notificationEmails || ''
    this.#FleetObject.AutoApprove = autoApprove || false
    this.#FleetObject.ApprovalMessage = approvalMessage || ''
    this.#FleetObject.FleetUser = fleetUsers || []
    this.#FleetObject.PublicRegistrationLinkUuid =
      publicRegistrationLinkUuid || ''
    this.#FleetObject.IsPublicRegistrationLinkEnabled =
      isPublicRegistrationLinkEnabled || false
    this.#FleetObject.StartSessionsWithLPR = startSessionsWithLPR || false
    this.#FleetObject.RegistrationOpenUntil = this.getRegistrationOpenUntil()
    this.#FleetObject.AppId = appId || 1
    this.#FleetObject.RegistrationRequestReceivedMessage =
      registrationRequestReceivedMessage ||
      'Your registration request has been received. You will receive a confirmation email when your registration is confirmed.'
    this.#FleetObject.ResetUsedLimitsEachMonth =
      resetUsedLimitsEachMonth || true
    this.#FleetObject.DailyLimitInCentsPerUser = dailyLimitInCentsPerUser || 0
    this.#FleetObject.MonthlyLimitInCentsPerUser =
      monthlyLimitInCentsPerUser || 0
    this.#FleetObject.MaxNumberOfUsers = maxNumberOfUsers || null
    this.#FleetObject.Currency = currency || 'EUR'
    this.#FleetObject.Managers = managers || []
  }

  getValidFrom() {
    if (!this.validFrom) {
      return null
    }
    return this.validFrom
  }

  getValidTo() {
    if (!this.validTo) {
      return null
    }
    return this.validTo
  }

  getRegistrationOpenUntil() {
    if (!this.registrationOpenUntil) {
      return null
    }
    return this.registrationOpenUntil
  }

  /**
   * Get Fleet Object
   * @return {Object} Fleet Javascript object
   */
  getObject() {
    return this.#FleetObject
  }
}
